import React, { useEffect, useState } from 'react';
import TransformFromPascalCase from 'components/Settings/Utilities/TransformFromPascalCase';
import { Navigation, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import normalize from 'components/Dashboard/utilities/normalizeString';
import 'swiper/css';
import 'swiper/css/navigation';
import { hex_is_light } from 'components/Reports/ui/ReportDesignButton';
import { useSiteSectionsNames } from 'utils/getAppSite';

const MenuItems = (props) => {
  const [swiperRef, setSwiperRef] = useState();
  const { resources, clickResources, typeOfContent, clickOnArrow, updatePosition, enabled = true, design } = props;
  const { barColour } = design ?? {};
  const { getName } = useSiteSectionsNames();
  useEffect(() => {
    if (updatePosition && !!swiperRef?.slideTo) {
      let resourcesArray = resources.split(',');
      let position = resourcesArray.indexOf(typeOfContent);
      swiperRef.slideTo(position);
    }
  }, [typeOfContent, swiperRef]);

  useEffect(() => {
    if (!!swiperRef?.update) {
      swiperRef.update();
    }
  }, [resources]);

  const finalResources = [...new Set(resources.split(',')?.filter((item) => item !== ''))];
  const changeName = (item) => {
    switch (item) {
      case 'Events':
        return 'Upcoming events';
      case 'RealtimeUtterances':
        return 'Parliament Live';
      case 'CommonsLibraryArticles':
        return 'Library material';
      case 'Tweets':
        return 'X posts';
      default:
        return TransformFromPascalCase(item);
    }
  };

  return (
    <>
      {resources !== '' && (
        <div
          className={`menu-embed-container menu-embed-items embed-padding`}
          style={{ backgroundColor: barColour ?? '#f9f9f9', color: hex_is_light(barColour) ? '#00122b' : '#fff' }}
        >
          <ul className='policy-list px-0 mb-0 '>
            <Swiper
              onSwiper={setSwiperRef}
              modules={[Navigation, Mousewheel]}
              slidesPerView={'auto'}
              navigation
              className={`embed-menu-swiper embed-padding`}
              mousewheel
              breakpoints={{
                550: {
                  slidesPerView: 'auto',
                },
              }}
              onSlideChange={(swiper) => {
                if (window.innerWidth < 550 && !!clickOnArrow) {
                  clickOnArrow(swiper.activeIndex);
                }
              }}
              enabled={enabled}
            >
              {finalResources.map((item, index) => {
                const label = getName({ property: changeName(item) });
                return (
                  <SwiperSlide
                    key={`item${index}`}
                    className={`slide-menu-${normalize(item)} slide-menu-${normalize(label)}`}
                  >
                    <li>
                      <button
                        className={`general-button menu-item-${normalize(item)} ${
                          typeOfContent === item ? 'active' : ''
                        }`}
                        onClick={async () => {
                          if (typeOfContent !== item) {
                            clickResources(item);
                          }
                        }}
                      >
                        {label}
                      </button>
                    </li>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </ul>
        </div>
      )}
    </>
  );
};

export default MenuItems;
